import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { EntityTemplateApplyTab } from '@/components/EntityTemplateApplyTab'
import { ErrorComponent } from '@/components/ErrorComponent'
import { LoadingComponent } from '@/components/LoadingComponent'
import { validateEntityTabSearchOptional } from '@/entity-config-runtime'
import { canReadEntityOrTab } from '@/integrations/casl/route-ability'
import { getEntityTabLabel } from '@/lib/entity-route-i18n'

const entityDetailRoute = getRouteApi('/_authenticated/$entity/$entityId')

export const Route = createFileRoute(
	'/_authenticated/$entity/$entityId/templates',
)({
	beforeLoad: ({ params, context }) => {
		const entity = String(params.entity ?? '')
		if (!canReadEntityOrTab(context.ability, entity, 'templates')) {
			throw new Error(
				`Missing read permission for tab "templates" on entity "${entity}"`,
			)
		}
	},
	validateSearch: validateEntityTabSearchOptional,
	component: EntityTemplatesRoute,
	staticData: {
		breadcrumb: () => ({ label: getEntityTabLabel('templates') }),
	},
	pendingComponent: LoadingComponent,
	errorComponent: ErrorComponent,
})

function EntityTemplatesRoute() {
	const { entity, entityId } = Route.useParams()
	const { breadcrumb } = entityDetailRoute.useLoaderData()

	return (
		<EntityTemplateApplyTab
			entity={entity}
			entityId={entityId}
			targetName={breadcrumb.label}
		/>
	)
}
